import styled from "styled-components";

export const Title = styled.div`
    width: auto;
    height: auto;
    
    margin: 10px 0 25px 0;

    span{
        font-size: 25px;
        text-transform: uppercase;
        color: white;
    };
`